/* Visible quantity controls; no cart requests and no variant/SKU mutations. */
(() => {
  if (customElements.get('fxl-quantity-stepper')) return;
  class FxlQuantityStepper extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.input = this.querySelector('input[name="quantity"]');
      this.minus = this.querySelector('[data-fxl-qty-adjust="-1"]');
      this.plus = this.querySelector('[data-fxl-qty-adjust="1"]');
      if (!this.input || !this.minus || !this.plus) return;
      this.ready = true;
      const bounds = () => ({
        min: this.input.min === '' ? 1 : Number(this.input.min),
        max: this.input.max === '' ? Infinity : Number(this.input.max),
        step: Number(this.input.step) > 0 ? Number(this.input.step) : 1
      });
      const normalize = () => {
        const { min, max, step } = bounds();
        const value = Number(this.input.value);
        this.input.value = String(Math.max(min, Math.min(max,
          Number.isFinite(value) ? min + Math.round((value - min) / step) * step : min)));
      };
      const sync = () => {
        const { min, max } = bounds();
        const value = this.input.value === '' ? min : Number(this.input.value);
        this.minus.disabled = value <= min;
        this.plus.disabled = value >= max;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-fxl-qty-adjust]');
        if (!button || !this.contains(button) || button.disabled) return;
        normalize();
        this.input.stepUp(Number(button.dataset.fxlQtyAdjust));
        sync();
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.input.addEventListener('input', sync);
      this.input.addEventListener('change', () => { normalize(); sync(); });
      sync();
    }
  }
  customElements.define('fxl-quantity-stepper', FxlQuantityStepper);
})();
